import { render, staticRenderFns } from "./EndClients.vue?vue&type=template&id=297c94e4&"
import script from "./EndClients.vue?vue&type=script&lang=js&"
export * from "./EndClients.vue?vue&type=script&lang=js&"
import style0 from "./EndClients.vue?vue&type=style&index=0&id=297c94e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports